// extracted by mini-css-extract-plugin
export default {"editColumn":"styles_editColumn__UuhZg","imageComponent":"styles_imageComponent__DnH24"};